import React, { useState } from 'react';
import { sanitizeInput } from '@core/utils/dompurify/dompurify.js';
import { Client } from 'FielderUtils/roles/roles';
import { getIdToken } from 'FielderUtils/session/Session';
import { createClientRequest } from '@core/api/client/client.service';
import { FIELDER } from '@core/constants/base.constants';
import {
  getCompaniesByFilterAsyncSelectCreateTask,
  getCompaniesInitialOptionsAsyncSelect,
} from 'FielderUtils/company/company';
import {
	getBranchesByFilterAsyncSelectCreateTask,
	getBranchesInitialOptionsAsyncSelect,
} from 'FielderUtils/branch/branch';
import { formatPhoneNumberIntl, isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import {
	validateUsername,
	validateName,
	validateLastname,
	validateSecondEmail,
	validateEmail,
} from '@core/utils/validations/FieldValidations';
import {FielderPhoneField} from '~/FielderElements/FielderElements.component';
import { useSelector, useDispatch } from 'react-redux';
import { selectSession } from '@core/store/modules/session/sessionSelectors';
import { useLanguage } from 'Context/LanguageContext';
import { FielderSmartTab, FielderSmartTabs } from '~/FielderElements/Utils/SmartTabNav';

import Grid from '@mui/material/Grid2';
import Datetime from 'react-datetime';
import ErrorCodes from 'FielderUtils/ErrorCodes';
import TextField from '~/TextField/TextField.component';
import Location from '~/Location/Location';
import AsyncSearch from 'OldComponents/AsyncSearch/AsyncSearch';
import SelectJobPosition from '../UsersSectionComponents/SelectJobPosition';
import moment from 'moment';

import './DateTime.css';
import './AddClient.css';
import 'FielderUtils/style.css';
import 'rc-time-picker/assets/index.css';
import '../Register/RegisterComponentStyles.css';
import { Button, Stack, Typography } from '@mui/material';
import { FielderButton } from 'OldComponents/ui';


const { txt: TXT_ID, btn: BTN_ID, dtpckr: DTPCK_ID } = FIELDER.idElement;
let beginningTime = null;
let endTime = null;
let validTime;
var branchMarkertsGlobal = [];

const AddClient = (props) => {
	
	/***************************  Session & User   ********************************/
	const session = useSelector(selectSession);	
	const user = session.user ? session.user : null;
	const idUser = session.user ? session.user.idUser : 0;
	const idAccount = session.user ? session.user.idAccount : 0;
	
	/*************************** Language & Dispatch ******************************/
	const dispatch = useDispatch();
	const lan = useLanguage();

	/***************************  States Client   ********************************/
	const [username , setUsername] = useState("");
	const [name, setName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [company, setCompany] = useState("");
	const [cellphone, setCellphone] = useState("");
	const [officePhone, setOfficePhone] = useState("");
	const [jobPosition, setJobPosition] = useState("");
	const [otherJobPosition, setOtherJobPosition] = useState("");
	const [attentionTimeFrom, setAttentionTimeFrom] = useState(null);
	const [attentionTimeTo, setAttentionTimeTo] = useState(null);

	/***************************  Location   ********************************/
	const [address, setAddress] = useState("");
	const [latitude, setLatitude] = useState("");
	const [longitude, setLongitude] = useState("");
	const [stateClient, setStateClient] = useState("");
	const [postalCode, setPostalCode] = useState("");
	const [country, setCountry] = useState("");
	const [timeZone, setTimeZone] = useState("");
	const [municipality, setMunicipality] = useState("");

	/***************************  Errors   ********************************/
	const [errorUserName, setErrorUserName] = useState(null);
	const [errorName, setErrorName] = useState(null);
	const [errorLastName, setErrorLastName] = useState(null);
	const [errorEmail, setErrorEmail] = useState(null);
	const [errorEmailConfirmation, setErrorEmailConfirmation] = useState(null);
	const [errorCellphone, setErrorCellphone] = useState(null);
	const [errorLocation, setErrorLocation] = useState(null);

	/***************************  Fields Validations   ********************************/
	const [emailConfirmation, setEmailConfirmation] = useState("");
	const [errorOfficePhone, setErrorOfficePhone] = useState('');
	const [errorMobilePhone, setErrorMobilePhone] = useState('');
	
	const [activateAlert, setActivateAlert] = useState(false);
	const [activateAlertUserName, setActivateAlertUserName] = useState(false);
	const [editMarker, setEditMarker] = useState(true);
	const [phoneNumberValue, setPhoneNumberValue] = useState("");
	const [countryIsoName, setCountryIsoName] = useState(null);
	
	/***************************  Branch & Company   ********************************/
	const [idBranchListArray, setIdBranchListArray] = useState([]);
	const [idCompany, setIdCompany] = useState(null);
	
	/*********************** Tabs ****************************/	
	const [tab, setTab] = useState('branch');
	
	
	/***************************  Validations   ********************************/
	const validateOfficePhone = () => {
		const isValid = officePhone.length > 0 && isValidPhoneNumber(officePhone);
		if (!isValid) setErrorOfficePhone(lan.messageErrorPhone);
		return isValid;
	};

	const validateCellPhone = () => {
		const isValid = phoneNumberValue.length > 0 && isValidPhoneNumber(phoneNumberValue);
		if (!isValid) setErrorMobilePhone(lan.messageErrorPhone);
		return isValid;
	};

	const validateLocation = () => {
		return (latitude !== 0 && longitude !== 0 && address !== '') || idBranchListArray.length > 0 || idCompany != null;
	};
	
	/***************************  Add Client   ********************************/
	const handleDoActionAddClient = () => {

		const isValidUserName = validateUsername(username);
		const isValidName = validateName(name);
		const isValidLastName = validateLastname(lastName);
		const isValidEmail = validateEmail(email);
		const isValidSecondEmail = validateSecondEmail(email, emailConfirmation);
		const isValidOfficePhone = validateOfficePhone();
		const isValidCellPhone = validateCellPhone();
		const isValidLocation = validateLocation();
				
		setActivateAlertUserName(false);
		setErrorUserName(!isValidUserName);
		setErrorName(!isValidName);
		setErrorLastName(!isValidLastName);
		setErrorEmail(!isValidEmail);
		setErrorEmailConfirmation(!isValidSecondEmail);
		setErrorOfficePhone(!isValidOfficePhone);
		setErrorMobilePhone(!isValidCellPhone);
		setErrorLocation(!isValidLocation);

		if (isValidUserName && isValidName && isValidLastName && isValidEmail &&
			isValidSecondEmail && isValidLocation && isValidCellPhone &&
			isValidOfficePhone && 	!activateAlertUserName) {
				document.getElementById('register-form-hint').style.display = 'none';
				executeCreateClient();
		} else {
			document.getElementById('register-form-hint').style.display = 'inline';
		}
	};

	const executeCreateClient = () => {
		
		const location = idBranchListArray.length > 0 || idCompany != null ? null : {
			address: address,
			latitude: latitude,
			longitud: longitude,
			state: stateClient,
			postalCode: postalCode,
			country: country,
			timeZone: timeZone,
			municipality: municipality,
			accountId: idAccount
		};

		const body = {
			clientUser: {
				idAccount: idAccount,
				idUser: idUser,
				userName: username,
				name: name,
				lastName: lastName,
				email: email,
				phoneNumber: formatPhoneNumberIntl(officePhone),
				status: 0,
				mobileNumber: formatPhoneNumberIntl(phoneNumberValue),
				attentionTimeFrom: attentionTimeFrom,
				attentionTimeTo: attentionTimeTo,
				jobPosition: jobPosition !== lan.other ? jobPosition : otherJobPosition,
				company: company,
				location: location,
				idBranches: idBranchListArray,
				role: Client.name,
				idCompany: idCompany,
				language: session.user.language,
			},
			isoName: countryIsoName,
		};

		const onSuccess = props.setDefaultFalseAddClient;
		const onError = ({ status }) => {
			if (status === ErrorCodes.FAIL_DUPLICATE_COGNITO_USER || status === ErrorCodes.DUPLICATED_USERNAME) {
				setActivateAlertUserName(true);
				setErrorUserName(true);
			} else {
				props.errorMessageCreation();
			}
		};

		const loadingConfig = { name: 'CREATE_CLIENT', dispatch };
		createClientRequest(body, onSuccess, onError, loadingConfig);
	};
	

	
	/***************************  On Change Field   ********************************/
	const onChangeField = (event) => {
		if (!event) return;
		const NUMBER_INPUTS = new Set([TXT_ID.phone, TXT_ID.mobile]);

		if (NUMBER_INPUTS.has(event.target.id)) {
			const re = /^[0-9\b]+$/;
			if (!re.test(event.target.value)) {
				return;
			}
		}
		const sanitizedInput = sanitizeInput(event.target.value);
		if( event.target.name === 'username') {
			setUsername(sanitizedInput);
		}else if( event.target.name === 'name') {
			setName(sanitizedInput);
		}else if( event.target.name === 'lastName') {
			setLastName(sanitizedInput);
		}else if( event.target.name === 'email') {
			setEmail(sanitizedInput);
		}else if( event.target.name === 'company') {
			setCompany(sanitizedInput);
		} else if( event.target.name === 'otherJobPosition') {
			setOtherJobPosition(sanitizedInput);
		}
	};

	const getUserNameHelperText = () =>   activateAlertUserName ? lan.userNameValidation : errorUserName ? lan.userNameFieldHelp : null;

	const onChangeFieldConfirmation = (event) => {
		const sanitizedInput = sanitizeInput(event.target.value);
		setEmailConfirmation(sanitizedInput);
	}

	/***************************  Update Location   ********************************/
	const updateLocation = (newLocation, coordinates) => {
		if (coordinates.lat != location.latitude && coordinates.lng != location.longitud) {
			setLatitude(coordinates.lat);
			setLongitude(coordinates.lng);
			setAddress(newLocation.address);
			setStateClient(newLocation.state);
			setPostalCode(newLocation.postalCode);
			setCountry(newLocation.country);
			setTimeZone(newLocation.timezone);
			setMunicipality(newLocation.municipality);
		}
	};

	const resetLocation = () => {
		setLatitude('');
		setLongitude('');
		setAddress('');
		setStateClient('');
		setPostalCode('');
		setCountry('');
		setTimeZone('');
		setMunicipality('');	
	}


	/***************************  Company   ********************************/	
	const getCompanyList = async (event) => {
		if (event.length > 0) {
		return await getCompaniesByFilterAsyncSelectCreateTask(event);
		}
	};

	const getInitialOptionsCompany = async () => await getCompaniesInitialOptionsAsyncSelect();

	const setFieldCompany = (event) =>{
		if(event){
		console.log('Selected companies:', event);
			setIdCompany(event ? event.value.id : null);
			branchMarkertsGlobal = [];
			const branchMarkertsGlobalValue = [];
			setIdBranchListArray([...branchMarkertsGlobalValue]);
			setEditMarker(false);
			console.log('Company selected, cleared branches and markers.');	
		} else {
			setEditMarker(true);
			setIdCompany(null);

		}
		resetLocation();

	} 

	/***************************  Branch   ********************************/	
	const getBranchList = async (event) => {
		if (event.length > 0) {
			return await getBranchesByFilterAsyncSelectCreateTask(event, idAccount, user, getIdToken());
		}
	};

	const getInitialOptionsBranch = async () => await getBranchesInitialOptionsAsyncSelect(idAccount, user, getIdToken());

	const getAllBranchMarkets = async (branches) => branches.map(({ value }) => ({
		id: value.id,
		position: {
		lat: parseFloat(value.location.latitude),
		lng: parseFloat(value.location.longitud),
		},
		title: value.idCustom
		? `${value.idCustom} - ${value.name}`
		: value.name,
	}));


	const setFieldBranches = async (event = []) => {
		const hasBranches = event.length > 0;
		const idBranchListArray = hasBranches
			? event.map(({ value }) => value.id)
			: [];

		const editMarker = !hasBranches;
		const branchMarkertsGlobalValue = hasBranches
			? [{ markers: await getAllBranchMarkets(event) }]
			: [];

		branchMarkertsGlobal = branchMarkertsGlobalValue;
		setIdBranchListArray(idBranchListArray);
		setEditMarker(editMarker);
		setIdCompany(null);
		resetLocation();
	};
	/***************************  Time Pickers   ********************************/
	const validateTime = () => {
		if (!beginningTime || !endTime) return;

		const start = moment(beginningTime, 'h:mm a');
		const end = moment(endTime, 'h:mm a');

		const isValid = start.isBefore(end);
		validTime = isValid;

		setActivateAlert(!isValid);

		if (isValid) {
			setAttentionTimeFrom(start.format('HH:mm'));
			setAttentionTimeTo(end.format('HH:mm'));
		}
	};

	const handleTimeChange = (value, type) => {
		if (!value?._d) return;

		const time = new Date(value._d);
		if (type === 'start') beginningTime = time;
		else if (type === 'end') endTime = time;

		validateTime();
	};

	/***************************  Job Position   ********************************/
	const handleChangeJobPosition = (value) => {
		setJobPosition(value);
	}
	
	/***************************  isActive Tab   ********************************/ 
	const isActive = (tabAux) => (tab === tabAux ? 'td-active' : '');
	/***************************  Render   ********************************/
	return (
		<Grid container spacing={2}>
			<Grid size={{ sm: 12, md: 6 }}>
        <Stack spacing={2}>
          <TextField
            id={TXT_ID.username}
            name='username'
            label={`${lan.userName}*`}
            value={username}
            onChange={(e) => onChangeField(e)}
            error={errorUserName}
            helperText={getUserNameHelperText()}
            maxSize={150}
          />
          <TextField
            id={TXT_ID.name}
            name='name'
            label={`${lan.name}*`}
            value={name}
            onChange={(e) => onChangeField(e)}
            error={errorName}
            helperText={errorName && lan.nameFieldHelp}
          />
          <TextField
            id={TXT_ID.lastName}
            name='lastName'
            label={`${lan.lastName}*`}
            value={lastName}
            onChange={(e) => onChangeField(e)}
            error={errorLastName}
            helperText={errorLastName && lan.lastNameFieldHelp}
          />
          <TextField
            id={TXT_ID.email}
            name='email'
            type='email'
            label={`${lan.email}*`}
            value={email}
            onChange={(e) => onChangeField(e)}
            error={errorEmail}
            helperText={errorEmail && lan.emailFieldHelp}
          />
          <TextField
            id={TXT_ID.emailConfirm}
            name='emailConfirmation'
            type='email'
            label={`${lan.confirmEmail}*`}
            value={emailConfirmation}
            onChange={(e) => onChangeFieldConfirmation(e)}
            error={errorEmailConfirmation}
            helperText={errorEmailConfirmation && lan.validateSameEmail}
          />
          <Location
            edit={editMarker}
            includeCoordinates={idBranchListArray.length <= 0 && idCompany == null}
            height='200px'
            label={lan.directionClient}
            locationUpdate={updateLocation}
            error={errorLocation}
            showDirection={idBranchListArray.length > 0 || idCompany != null}
            markers={branchMarkertsGlobal}
            idCompany={idCompany}
            idBranchListArray={idBranchListArray}
          />
        </Stack>
			</Grid>
			<Grid size={{ sm: 12, md: 6 }}>
        <Stack spacing={2}>
          <TextField
            id={TXT_ID.companyName}
            name='company'
            label={lan.company}
            onChange={(e) => onChangeField(e)}
            value={company}
          />
          <Grid container>
            <Grid size={12}>
              <FielderSmartTabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
                sx={{ borderBottom: '1px solid #eee' }}
              >
                <FielderSmartTab id="nav-branch" value="branch" label={lan.branch} className={`td-nav-title ${isActive('branch')}`} />
                <FielderSmartTab id="nav-company" value="company" label={lan.company} className={`td-nav-title ${isActive('company')}`} />
              </FielderSmartTabs>
            </Grid>
            <Grid size={12} sx={{ mt: 1 }}>
              {tab === 'branch' && (
                <AsyncSearch
                  className='my-0'
                  getOptions={getBranchList}
                  multiple
                  defaultValue={[]}
                  onChange={setFieldBranches}
                  label={lan.placeHolderBranch}
                  lan={lan}
                  id='select-branch-add-client'
                  showInitialOptions
                  getInitialOptions={getInitialOptionsBranch}
                />
              )}
              {tab === 'company' && (
                <AsyncSearch
                  className='my-0'
                  getOptions={getCompanyList}
                  onChange={ setFieldCompany}
                  label={lan.placeHolderCompany}
                  lan={lan}
                  id='select-company-client'
                  showInitialOptions
                  getInitialOptions={getInitialOptionsCompany}
                />
              )}
            </Grid>
          </Grid>
          <Grid container>
            <Typography variant={'caption'}>{lan.workingHours}</Typography>
            <Grid size={12}>
              {activateAlert && (
                <Grid size={12}>{lan.hourValidation}</Grid>
              )}
              <Grid container size={12} spacing={1}>
                <Grid size={6}>
                  <Datetime
                    id={DTPCK_ID.workingHoursFrom}
                    className='id-date-from'
                    inputProps={{ placeholder: lan.from, readOnly: true }}
                    dateFormat={false}
                    onChange={(value) => handleTimeChange(value, 'start')}
                  />
                </Grid>
                <Grid size={6}>
                  <Datetime
                    id={DTPCK_ID.workingHoursTo}
                    className='id-date-to'
                    inputProps={{ placeholder: lan.to, readOnly: true }}
                    dateFormat={false}
                    onChange={(value) => handleTimeChange(value, 'end')}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <FielderPhoneField
            id={TXT_ID.phone}
            label={lan.officePhone}
            value={officePhone}
            onChange={value => {
              setErrorCellphone('');
              setOfficePhone(value === undefined ? '' : value);
            }}
            lan={lan}
            isRequired={false}
            externalError={errorOfficePhone}
          />
          <FielderPhoneField
            id={TXT_ID.mobile}
            label={lan.mobilePhone}
            value={cellphone}
            onChange={value => {
              const valueNumber = value || '';
              const formattedPhone = formatPhoneNumberIntl(valueNumber);
              let parsedNumber;
              try {
                parsedNumber = parsePhoneNumber(valueNumber);
              } catch (err) {
                console.warn('Failed to parse phone number:', err);
              }

              setErrorMobilePhone('');
              setPhoneNumberValue(formattedPhone);
              setCountryIsoName(parsedNumber?.country);

            }}
            lan={lan}
            isRequired={true}
            externalError={errorMobilePhone}
          />
          <SelectJobPosition
            lan={lan}
            onChange={handleChangeJobPosition}
            defaultValue='0'
          />
          {jobPosition === lan.other && (
            <TextField
              id={TXT_ID.jobPosition}
              name='otherJobPosition'
              label={lan.anotherJob}
              value={otherJobPosition}
              onChange={(e) => onChangeField(e)}
              size='small'
            />
          )}
          <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
            <Typography variant={'caption'}>*{lan.requiredFields}</Typography>
          </Grid>
          <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center" }}>
            <Grid size={8}>
              <Button
                variant="contained" size={'large'} type='submit' id={BTN_ID.create} onClick={handleDoActionAddClient}
                fullWidth
              >
                {lan.add}
              </Button>
            </Grid>
          </Grid>
        </Stack>
			</Grid>
		</Grid>	
	);
}
export default AddClient;
